import gbAntSelectDatePicker from "./src/gb-ant-select-date-picker.vue";
const gbAntSelectDatePickerCompenet = function(Vue) {
  Vue.component(gbAntSelectDatePicker.name, gbAntSelectDatePicker);
};
export default gbAntSelectDatePickerCompenet;
